import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import permissionTypes from '../components/atoms/permissionsGate/permissionTypes';

export default {
  attributeName: 'faqLinks',
  label: 'FAQ Links',
  isDragable: false,
  canChangePosition: true,
  sortingPositionIndex: 'sortingIndex',
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  isMultiSelectable:false,
  emptyMessage: "You don't have FAQ links, click on the \"+\" icon to create one.",

  newButton:false,
  createURL:'appId/areaId/appFaqLinks',
  getURL:'appId/areaId/appFaqLinks',
  updateURL:'appId/areaId/appFaqLinks',
  removeURL:'appId/areaId/appFaqLinks',
  sessionParams: ['appId', 'areaId'],

  deleteRecordText:"You are about to delete the FAQ link. Do you still want to proceed?",
  // popupContentFormNew:[formGraphicManagerVODManifestContent],
  // popupContentFormEdit:[formGraphicManagerVODManifestContent],
  // popupContentFormSecondary:[formSportRoomConfigContentMassUpdate],
  
  fields: [
    
    {
      attributeName: 'faqStatement',
      label: 'FAQ statement',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: ' Statement for the FAQ',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'faqUrl',
      label: 'FAQ url',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'URL for the FAQ statement',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    
  ],
};